import { render } from "./OptionList.vue?vue&type=template&id=8e0f951c&ts=true"
import script from "./OptionList.vue?vue&type=script&lang=ts"
export * from "./OptionList.vue?vue&type=script&lang=ts"

import "./OptionList.vue?vue&type=style&index=0&id=8e0f951c&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__